var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC2RetractableAwningClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 57h4v4H8v-4h4V34.77a7.21 7.21 0 001.83.23c.736 0 1.467-.111 2.17-.33V57h13V34.3a8.75 8.75 0 001.76-1.17 1.91 1.91 0 012.24 0V57h27V34.72c.65.19 1.323.284 2 .28a7.44 7.44 0 002-.28V57zm4-31.25v2.84c-2.13 0-2.75 1.2-4 1.91a4.29 4.29 0 01-4 0c-1.27-.7-1.89-1.92-4-1.92-3 0-3 2.41-6 2.41s-3-2.41-6-2.41-3 2.41-6 2.41-3-2.41-6-2.41-3 2.41-6 2.41-3-2.41-6-2.41c-2 0-2.71 1.11-3.86 1.82a3.89 3.89 0 01-2.17.59A4 4 0 0112 30.6c-1.43-.68-2.16-2-5-2v-2.74L14.77 17h45.86L68 25.75zm-4.52.25l-4.11-5H16l-4.38 5h51.86zM25 47a1.5 1.5 0 100-3h-2a1.5 1.5 0 100 3h2z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C2_Retractable_awning_close.01541872.svg";
export { SvgC2RetractableAwningClose as ReactComponent };